import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { first, last, map, mergeMap, tap } from 'rxjs';
import { FinancialService } from 'src/app/services/api/financial.service';
import { GeneralService, GlobalService, LocalStorageService } from 'src/app/services/index.service';
@Component({
  selector: 'app-entity-header-option',
  templateUrl: './entity-header-option.component.html',
  styleUrls: ['./entity-header-option.component.scss']
})
export class EntityHeaderOptionComponent implements OnInit {
  constructor(
    private router: Router,
    public general: GeneralService,
    public globalService: GlobalService,
    private storageService: LocalStorageService,
    private financialService: FinancialService
  ) { }
  expandAccountClass = { 'max-h-[8.35rem]': false, 'mt-3': false }
  profileIsOpen: boolean = false
  profileClass = { 'opacity-0': true, 'hidden': true }
  isExpand: boolean = false;
  balancedValue = '0'

  ngOnInit(): void {
    this.financialService.getBalancedValueObs().pipe().subscribe(
      (data:any) => {
        this.balancedValue = data
        let wallet = +this.general.convDegitToEnglish(data.toString().replaceAll(',', ''))
        wallet = +wallet.toString().substring(0, data.toString().length - 1)
        this.balancedValue = wallet.toLocaleString()
      }
    )
    setTimeout(() => {
    }, 300);
  }
  showProfile() {
    this.profileIsOpen = true
    this.profileClass = { 'opacity-0': true, 'hidden': false }
    setTimeout(() => { this.profileClass = { 'opacity-0': false, 'hidden': false } }, 150)
  }
  scrollToViewNavigate() {
    this.globalService.scrollToTopOfView('body')
  }
  hideProfile() {
    this.profileClass = { 'opacity-0': true, 'hidden': false }
    setTimeout(() => { this.profileClass = { 'opacity-0': true, 'hidden': true } }, 150)
    setTimeout(() => { this.profileIsOpen = false }, 150)
  }
  changeProfileState() {
    this.profileIsOpen ? this.hideProfile() : this.showProfile()
  }
  skipChangeUrl(destination: string) {
    let basePath = destination.split('/')[0] == "" ? destination.split('/')[1] : destination.split('/')[0]
    this.globalService.scrollTop()
    this.router.navigateByUrl(`/${destination}/`, { skipLocationChange: true }).then(() =>
      this.router.navigate([destination])
    )
  }
  logout() {
    this.globalService.jwtService.logout()
  }
  accountUrl() {
    let user = this.globalService.jwtService.getCurrentAccountData();
    if (user?.last_logined_role == 'USER') {
      return `/hamafarin/${user?.username}-${this.general.RegProfileUrl(user?.first_name)}-${this.general.RegProfileUrl(user?.last_name)}`
    }
    else {
      return `/nahad/${user?.username}`
    }
  }

  profileUrl(role:any=null,account:any=null) {
    if(role){
      if (role == 'USER') {
        return `/hamafarin/${account?.username}-${this.general.RegProfileUrl(account?.first_name)}-${this.general.RegProfileUrl(account?.last_name)}`
      }
      else {
        return `/nahad/${account?.username}`
      }
    }else{
      let user = this.globalService.jwtService.getCurrentAccountData();
      if (user?.last_logined_role == 'USER') {
        return `/hamafarin/${user?.username}-${this.general.RegProfileUrl(user?.first_name)}-${this.general.RegProfileUrl(user?.last_name)}`
      }
      else {
        return `/nahad/${user?.username}`
      }
    }
  }

  expandPanelAccount() {
    this.isExpand = !this.isExpand;
    if (this.isExpand) {
      this.expandAccountClass = { 'max-h-[8.35rem]': true, 'mt-3': true }
    } else {
      this.expandAccountClass = { 'max-h-[8.35rem]': false, 'mt-3': false }
    }
  }
  switchAccount(username: string, role: string, organ: any = null) {
    let refreshToken = this.globalService.jwtService.getRefreshToken()
    this.globalService.jwtService.changeRole(refreshToken, role == 'ORGAN' ? username : null).pipe(
      (
        mergeMap((response:any)=>{
          this.globalService.jwtService.distributionToken(response);
          return this.getBalancedWalletObs().pipe(
            map(()=>response)
          )
        })
      )
    ).subscribe(
      (token) => {
        this.storageService.setData('identity', { role: role, username: username })
        let convertData: any = JSON.parse(JSON.stringify(this.globalService.jwtService.getCurrentUserData())) as typeof this.globalService.jwtService.getCurrentUserData;
        setTimeout(()=>{
          if (role == 'USER') {
            convertData.last_logined_role = 'USER'
            convertData.last_logined_role_username = username
            this.globalService.jwtService.setCurrentAccountData(convertData)
          } else {
            let role = this.storageService.getData('identity').role
            this.globalService.jwtService.setSelectedOrganData(organ)
            this.globalService.jwtService.getCurrentAccountData().last_logined_role = 'ORGAN'
            this.globalService.jwtService.getCurrentAccountData().last_logined_role_username = role == 'USER' ? username : this.globalService.jwtService.getCurrentAccountData().username
            convertData.last_logined_role = 'ORGAN'
            convertData.last_logined_role_username = role == 'USER' ? '' : this.globalService.jwtService.getCurrentAccountData().username
            this.globalService.jwtService.getCurrentAccountData().banner_photo = organ.banner
            this.globalService.jwtService.getCurrentAccountData().username = organ.username
            this.globalService.jwtService.getCurrentAccountData().profile_photo = organ.logo
            this.globalService.jwtService.getCurrentAccountData().org_banner_photo = organ.org_banner
            this.globalService.jwtService.getCurrentUserData().org_profile_photo = organ.org_logo
            this.globalService.jwtService.getCurrentAccountData().first_name = organ.name
            this.globalService.jwtService.getCurrentAccountData().last_name = ''
            this.globalService.jwtService.getCurrentAccountData().profile_text = organ.slogan
            this.globalService.jwtService.getCurrentAccountData().info = organ.description
          }
        },300)
        this.globalService.jwtService.setCurrentUserData(convertData)
        this.globalService.scrollTop()
        this.router.navigateByUrl(`/${this.profileUrl(role,role=='USER' ? convertData : organ)}/`, { skipLocationChange: true }).then(() =>
          this.router.navigate([this.profileUrl(role,role=='USER' ? convertData : organ)])
        )
        this.expandPanelAccount()
      },
      (error) => {
        // console.log(error)
      }
    )
  }
  getBalancedWalletObs() {
    return this.financialService.getWallet().pipe(
      tap((response:any)=>{
        let x = +this.general.convDegitToEnglish(response.balance.toString().replaceAll(',', ''))
        x = +x.toString().substring(0, response.balance.toString().length - 1)
        this.balancedValue = x.toLocaleString()
        this.financialService.setBalancedValue(this.balancedValue)
      })
    )
  }
  checkFemaleGender() {
    return this.globalService.returnGender(this.globalService.jwtService.getCurrentAccountDataObs()) == 'FEMALE'
  }
  checkDarkMode() {
    return this.globalService.checkDarkMode()
  }
  isOrganObs(){
    return this.globalService.checkUserIsOrganObs()
  }
}